import {faChildReaching, faHeartPulse, faRuler, faSmoking} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import {OptionButton} from "../../../../designSystem/components/OptionButton";

export type MedicalOrganizationTagFormData = {
  smokingCessation: boolean;
  icope: boolean;
  hpaPrevention: boolean;
  adultHealthScreening: boolean;
};

export const initialMedicalOrganizationTagFormData: MedicalOrganizationTagFormData = {
  smokingCessation: false,
  icope: false,
  hpaPrevention: false,
  adultHealthScreening: false,
};

const optionConfigs: {
  key: keyof MedicalOrganizationTagFormData;
  icon: typeof faSmoking;
  label: string;
}[] = [
  {key: "smokingCessation", icon: faSmoking, label: "戒菸"},
  {key: "icope", icon: faRuler, label: "ICOPE評估醫事單位"},
  {key: "hpaPrevention", icon: faHeartPulse, label: "代謝症候群防治機構"},
  {key: "adultHealthScreening", icon: faChildReaching, label: "成人健檢之醫療院所"},
];

type Props = {
  formData: MedicalOrganizationTagFormData;
  onChangeFormData: (next: MedicalOrganizationTagFormData) => void;
};

export const MedicalOrganizationTags = ({formData, onChangeFormData}: Props) => {
  const toggleOption = (key: keyof MedicalOrganizationTagFormData) => {
    onChangeFormData({
      ...formData,
      [key]: !formData[key],
    });
  };

  return (
    <div className="flex gap-2 mb-2 flex-wrap px-2">
      {optionConfigs.map(({key, icon, label}) => (
        <OptionButton
          key={key}
          isSelected={formData[key]}
          onClick={() => toggleOption(key)}
          icon={icon}
          label={label}
        />
      ))}
    </div>
  );
};
